// extracted by mini-css-extract-plugin
export default {"ReplyButton":"qc_a bik_wx bik_jb bik_xl bik_i bik_j bik_q bik_vt bik_et bik_so bik_sp bik_eg","ReplyButton__icon":"qc_b bik_rz"};